module.exports = __webpack_public_path__ + "static/demo-3f7591b76302063dd3e81cfc6fd74026.gif";